import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { projectFirestore } from './firebase/config';
import { collection, getDocs } from 'firebase/firestore';

// components
import Navbar from './components/Navbar';
import Home from './Pages/home/Home';
import About from './Pages/about/About';
import ProjectPage from './Pages/projects/ProjectPage';
import Projects from './Pages/projects/Projects';

import logo from './assets/MyLogo.svg';

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [project, setProject] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(false);
  const [loadPage, setLoadPage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadPage(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeNav = () => {
    if (isOpen) setIsOpen(false);
  };

  useEffect(() => {
    setIsPending(true);

    const getProjects = async () => {
      try {
        const projectsRef = collection(projectFirestore, 'projects');
        const snapshot = await getDocs(projectsRef);

        if (snapshot.empty) {
          setError('No Project Loading');
          setIsPending(false);
        } else {
          let result = [];
          snapshot.docs.forEach(doc => {
            result.push({ id: doc.id, ...doc.data() });
          });
          setProject(result);
          setIsPending(false);
        }
      } catch (err) {
        setError(err.message);
        setIsPending(false);
      }
    };
    getProjects();
  }, []);

  return (
    <>
      <div
        className={` ${
          loadPage
            ? 'hidden'
            : 'fixed top-0 left-0 min-h-full min-w-full z-[100] bg-navys-300 flex flex-col justify-center items-center text-accent'
        }`}
      >
        <img
          src={logo}
          alt="odeco-logo"
          className="w-28 mb-4 animate-slideDown"
        />
        <p className="uppercase animate-slideRight text-3xl font-bold mb-4">
          odeco
        </p>
        <p className="capitalize animate-blink text-lg md:text-xl">
          redefining web development
        </p>
      </div>
      {loadPage && (
        <BrowserRouter>
          <Navbar
            isOpen={isOpen}
            toggleMenu={toggleMenu}
            close={closeNav}
            setIsOpen={setIsOpen}
          />
          {isOpen && (
            <div
              className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-10"
              onClick={toggleMenu}
            ></div>
          )}
          <Routes>
            <Route
              path="/"
              element={
                <Home projects={project} isPending={isPending} error={error} />
              }
            />
            <Route path="/about" element={<About />} />
            <Route
              path="/projects"
              element={
                <Projects
                  projects={project}
                  isPending={isPending}
                  error={error}
                />
              }
            />
            <Route path="/project/:id" element={<ProjectPage />} />
          </Routes>
          <footer className="w-fit mb-5 mt-4 mx-auto text-gold text-opacity-50 text-lg">
            &copy; Okechukwu Chidera
          </footer>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
